<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <!-- 搜索条件表单 -->
        <el-form :model="queryParams" ref="queryForm" size="small" label-width="100px">
          <!-- 第一行搜索条件 -->
          <el-row :gutter="24" type="flex">
            <el-col :span="5">
              <el-form-item label="客户名称">
                <el-input v-model="queryParams.compName" placeholder="请输入客户名称" clearable @keyup.enter.native="handleQuery" />
                <CustomerDetails v-model="queryParams.compName" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="使用单位">
                <el-input v-model="queryParams.useUntName" placeholder="请输入使用单位" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="小区名称">
                <el-input v-model="queryParams.houseName" placeholder="请输入小区名称" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="到检年月">
                <el-date-picker v-model="queryParams.inspectionMonthList" type="months" placeholder="请选择到检年月" clearable value-format="yyyy-MM" style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="发票号">
                <el-input v-model="queryParams.invoiceNo" placeholder="请输入发票号" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二行搜索条件 -->
          <el-row :gutter="24" type="flex">
            <el-col :span="5">
              <el-form-item label="开票主体">
                <el-select v-model="queryParams.invoiceSubject" placeholder="请选择开票主体" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="晨宇安全科技集团有限公司" value="晨宇安全科技集团有限公司"></el-option>
                  <el-option label="晨宇安全科技集团有限公司泉州分公司" value="晨宇安全科技集团有限公司泉州分公司"></el-option>
                  <el-option label="晨宇安全科技集团有限公司漳州分公司" value="晨宇安全科技集团有限公司漳州分公司"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="开票金额">
                <el-input v-model="queryParams.invoiceAmount" placeholder="请输入开票金额" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="申请时间">
                <el-date-picker v-model="queryParams.applyTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 100%;"
                                @change="handleQuery">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="开票时间">
                <el-date-picker v-model="queryParams.invoiceTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 100%;"
                                @change="handleQuery">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="是否回款">
                <el-select v-model="queryParams.receiptStatus" placeholder="请选择" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="已回款" :value="1"></el-option>
                  <el-option label="未回款" :value="-1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第三行搜索条件 -->
          <el-row :gutter="24" type="flex">
            <el-col :span="5">
              <el-form-item label="状态">
                <el-select v-model="queryParams.applyStatus" placeholder="请选择状态" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="全部" :value="undefined"></el-option>
                  <el-option label="开票中" :value="0"></el-option>
                  <el-option label="已开票" :value="1"></el-option>
                  <el-option label="已撤销" :value="2"></el-option>
                  <el-option label="红冲申请" :value="3"></el-option>
                  <el-option label="已重新开票" :value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 操作按钮 - 使用权限按钮组件 -->
          <div style="text-align: center; margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleQuery="handleQuery" @handleApply="handleApply" @handleExport="handleExport" />
          </div>

          <!-- 数据表格 -->
          <el-table :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" v-loading="loading"
                    element-loading-text="正在查询数据..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" height="500">
            <el-table-column type="index" label="序号" width="60" align="left" :index="indexMethod"></el-table-column>
            <el-table-column label="开票主体" align="left" prop="invoiceSubject" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="使用单位" align="left" prop="useUntName" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="小区名称" align="left" prop="houseName" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="客户名称" align="left" prop="compName" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="税号" align="left" prop="taxNo" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="开票金额" align="left" prop="invoiceAmount" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.invoiceAmount ? '¥' + scope.row.invoiceAmount : '-' }}
              </template>
            </el-table-column>
            <el-table-column label="开票时间" align="left" prop="invoiceTime" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.invoiceTime ? scope.row.invoiceTime.split(' ')[0] : '-' }}
              </template>
            </el-table-column>
            <el-table-column label="发票号" align="left" prop="invoiceNo" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="申请人" align="left" prop="applicantName" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="申请时间" align="left" prop="applyTime" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.applyTime ? scope.row.applyTime.split(' ')[0] : '-' }}
              </template>
            </el-table-column>
            <el-table-column label="状态" align="left" prop="applyStatus" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-tag :type="getStatusType(scope.row.applyStatus)">
                  {{ getStatusText(scope.row.applyStatus) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="原发票号" align="left" prop="originInvoiceNo" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="申请号" align="left" prop="applyNo" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" align="left" width="400" fixed="right">
              <template slot-scope="scope">
                <!-- 使用权限按钮组件，根据是否已开票动态禁用修改按钮 -->
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" :disabledButtons="getDisabledButtons(scope.row)" @redReversal="redReversal(scope.row)"
                                     @handleInvoiceManage="handleInvoiceManage(scope.row)" @handleDetail="handleDetail(scope.row)" @ViewAttachments="ViewAttachments(scope.row)"
                                     @handleEdit="handleEdit(scope.row)" @handleDelete="handleDelete(scope.row)" />
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-form>
      </el-col>
    </el-row>

    <!-- 引入弹出层组件 -->
    <InvoiceDialog ref="invoiceDialog" @refresh="getList" />
    <RedReversalDialog ref="redReversalDialog" @refresh="getList" />

    <!-- PDF预览对话框 -->
    <el-dialog title="附件预览" :visible.sync="pdfPreviewVisible" width="80%" append-to-body>
      <PdfImgViewer ref="pdfImgViewer" :fileName="pdfFileName" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="pdfPreviewVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import InvoiceDialog from './InvoiceDialog.vue';
import PdfImgViewer from '@/components/pdfview/PdfImgViewer.vue';
import RedReversalDialog from './redReversal.vue';
import { queryInvoiceList, deleteInvoice, exportInvoice, checkInvoiceOperation } from '@/api/contract/contract';

export default {
  name: 'InvoiceApplication',
  components: {
    InvoiceDialog,
    PdfImgViewer,
    RedReversalDialog
  },
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 表格数据
      tableData: [],
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // PDF预览相关
      pdfPreviewVisible: false,
      pdfFileName: '',
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 10,
        useUntName: undefined, // 使用单位
        houseName: undefined, // 小区名称
        compName: undefined, // 客户名称
        inspectionMonthList: [], // 到检年月
        invoiceSubject: undefined, // 开票主体
        invoiceAmount: undefined, // 开票金额
        applyTime: null, // 申请时间
        applyStatus: 0, // 申请状态（0=开票中，1=已开票，2=已撤销）
        invoiceTime: null, // 开票时间
        invoiceNo: undefined, // 发票号
        receiptStatus: undefined // 是否回款（1=已回款，-1=未回款）
      }
    };
  },
  created () {
    this.getList();
  },
  methods: {
    /**
     * 操作前校验：是否允许继续执行当前操作
     * @param {Object} row - 当前行数据
     * @param {String|Number} operType - 操作类型 1-删除，2-发票管理，3-红冲
     * @returns {Promise<Boolean>} true-允许，false-拦截
     */
    async canContinueOperation (row, operType) {
      const originInvoiceNo = row && row.invoiceNo;
      // if (!originInvoiceNo) {
      //   this.$message.warning('缺少原始发票号(originInvoiceNo)，无法校验该操作');
      //   return false;
      // }
      try {
        const res = await checkInvoiceOperation({
          operType: String(operType),
          originInvoiceNo: originInvoiceNo
        });
        if (res && res.retCode === 'ok') {
          const ok = !!res.additionalData;
          if (!ok) {
            this.$message.warning('该条数据下有待红冲操作的数据，请操作后重试');
          }
          return ok;
        }
        this.$message.error((res && res.retMsg) || '操作校验失败');
        return false;
      } catch (e) {
        console.error('操作校验失败:', e);
        this.$message.error('操作校验失败');
        return false;
      }
    },
    /**
     * 获取禁用的按钮列表
     * @param {Object} row - 当前行数据
     * @returns {Array} 禁用的按钮方法名数组
     */
    getDisabledButtons (row) {
      const disabledButtons = [];
      // 如果已开票（有发票号），则禁用修改按钮
      if (row.invoiceNo) {
        disabledButtons.push('handleEdit');
      }
      if (row.applyStatus !== 1) {
        disabledButtons.push('redReversal');
      }
      if (row.applyStatus === 4) {
        disabledButtons.push('handleInvoiceManage');
        disabledButtons.push('handleDelete');
      }
      if (row.applyStatus === 2) {
        disabledButtons.push('handleEdit');
        disabledButtons.push('handleDelete');
        disabledButtons.push('handleInvoiceManage');
        disabledButtons.push('redReversal');
        disabledButtons.push('ViewAttachments');
        disabledButtons.push('handleDetail');
      }

      return disabledButtons;
    },

    /**
     * 计算序号（考虑分页）
     */
    indexMethod (index) {
      return (this.queryParams.currPage - 1) * this.queryParams.pageSize + index + 1;
    },

    /**
     * 获取状态文本
     * @param {String} status - 状态值
     * @returns {String} 状态文本
     */
    getStatusText (status) {
      switch (status) {
        case 0:
          return '开票中';
        case 1:
          return '已开票';
        case 2:
          return '已撤销';
        case 3:
          return '红冲申请';
        case 4:
          return '已重新开票';
        default:
          return '未知';
      }
    },

    /**
     * 获取状态标签类型
     * @param {String} status - 状态值
     * @returns {String} 标签类型
     */
    getStatusType (status) {
      switch (status) {
        case 0:
          return 'warning';
        case 1:
          return 'success';
        case 2:
          return 'danger';
        default:
          return 'info';
      }
    },
    /**
     * 查询列表数据
     */
    getList () {
      this.loading = true;

      // 处理日期范围参数
      const params = { ...this.queryParams };
      
      // 处理申请时间范围
      if (params.applyTime && params.applyTime.length === 2) {
        params.applyTimeStart = params.applyTime[0];
        params.applyTimeEnd = params.applyTime[1];
      }
      delete params.applyTime;
      
      // 处理开票时间范围
      if (params.invoiceTime && params.invoiceTime.length === 2) {
        params.invoiceTimeStart = params.invoiceTime[0];
        params.invoiceTimeEnd = params.invoiceTime[1];
      }
      delete params.invoiceTime;

      // 调用查询发票申请列表的API
      queryInvoiceList(params).then(res => {
        if (res && res.retCode === 'ok' && res.additionalData) {
          const { records = [], current = this.queryParams.currPage, size = this.queryParams.pageSize, total = 0 } = res.additionalData || {};
          this.tableData = records;
          this.queryParams.currPage = current;
          this.queryParams.pageSize = size;
          this.total = total;
        } else {
          this.$message.error((res && res.retMsg) || '获取发票申请列表失败');
        }
        this.loading = false;
      }).catch(error => {
        console.error('获取发票申请列表失败:', error);
        this.loading = false;
        // this.$message.error('获取发票申请列表失败');
      });
    },

    /**
     * 查询按钮
     */
    handleQuery () {
      this.queryParams.currPage = 1;
      this.getList();
    },

    /**
     * 重置按钮
     */
    handleReset () {
      this.queryParams = {
        currPage: 1,
        pageSize: 10,
        useUntName: undefined,
        houseName: undefined,
        compName: undefined,
        inspectionMonthList: [],
        invoiceSubject: undefined,
        invoiceAmount: undefined,
        applyTime: null,
        applyStatus: 0,
        invoiceTime: null,
        invoiceNo: undefined,
        receiptStatus: undefined
      };
      this.getList();
    },

    /**
     * 申请按钮 - 打开申请弹窗
     */
    handleApply () {
      this.$refs.invoiceDialog.openDialog('apply');
    },

    /**
     * 修改按钮 - 打开修改弹窗
     * 注意：如果已填写发票号则不能修改
     * @param {Object} row - 当前行数据
     */
    handleEdit (row) {
      if (row.invoiceNo) {
        this.$message.warning('该申请已开票，不能修改');
        return;
      }
      this.$refs.invoiceDialog.openDialog('edit', row);
    },

    /**
     * 删除按钮
     * @param {Object} row - 当前行数据
     */
    async handleDelete (row) {
      const canContinue = await this.canContinueOperation(row, 1);
      if (!canContinue) return;
      this.$confirm('确定要删除该发票申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用删除发票申请的API
        deleteInvoice(row.id).then(res => {
          if (res && res.retCode === 'ok') {
            this.$message.success('删除成功');
            this.getList();
          } else {
            this.$message.error((res && res.retMsg) || '删除失败');
          }
        }).catch(error => {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },

    /**
     * 发票管理按钮 - 打开发票管理弹窗
     * @param {Object} row - 当前行数据
     */
    async handleInvoiceManage (row) {
      const canContinue = await this.canContinueOperation(row, 2);
      if (!canContinue) return;
      this.$refs.invoiceDialog.openDialog('invoice', row);
    },

    /**
     * 详情按钮 - 打开详情弹窗
     * @param {Object} row - 当前行数据
     */
    handleDetail (row) {
      this.$refs.invoiceDialog.openDialog('detail', row);
    },

    /**
     * 导出按钮
     */
    handleExport () {
      this.$message.success('正在导出发票申请数据...');

      // 调用导出发票申请的API
      exportInvoice(this.queryParams).then(response => {
        // 创建下载链接
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);

        // 创建下载链接元素
        const link = document.createElement('a');
        link.href = url;
        link.download = `发票申请数据_${new Date().getTime()}.xlsx`; // 文件名

        // 触发下载
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message.success('导出成功');
      }).catch(error => {
        console.error('导出失败:', error);
        this.$message.error('导出失败：' + (error.message || '未知错误'));
      });
    },
    /**
     * 查看附件 - 预览PDF文件
     * @param {Object} row - 当前行数据
     */
    ViewAttachments (row) {
      // 检查是否有上传的文件UUID
      if (!row.invoiceFileName) {
        this.$message.warning('该申请暂无附件');
        return;
      }

      // 设置文件名并打开预览对话框
      this.pdfFileName = row.invoiceFileName;
      this.pdfPreviewVisible = true;

      // 等待DOM更新后初始化PDF查看器
      this.$nextTick(() => {
        if (this.$refs.pdfImgViewer) {
          this.$refs.pdfImgViewer.init();
        }
      });
    },
    /**
     * 分页大小改变
     * @param {Number} val - 新的分页大小
     */
    handleSizeChange (val) {
      this.queryParams.pageSize = val;
      this.queryParams.currPage = 1;
      this.getList();
    },

    /**
     * 当前页改变
     * @param {Number} val - 新的当前页
     */
    handleCurrentChange (val) {
      this.queryParams.currPage = val;
      this.getList();
    },
    /**
     * 红冲按钮
     * @param {Object} row - 当前行数据
     */
    async redReversal (row) {
      const canContinue = await this.canContinueOperation(row, 3);
      if (!canContinue) return;
      this.$refs.redReversalDialog.openDialog(row);
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
